import type { ReactElement, ReactNode } from "react";
import { useEffect, useRef } from "react";
import { SessionStatus, selectStatus, useSession } from "./session";

type SessionGateProps = {
  children: ReactNode;
};

export const SessionGate = ({ children }: SessionGateProps): ReactElement | null => {
  const status = useSession(selectStatus);
  const restore = useSession((state) => state.restore);
  const started = useRef(false);

  useEffect(() => {
    if (started.current) return;
    started.current = true;
    void restore();
  }, [restore]);

  if (status === SessionStatus.RESTORING) return null;

  return <>{children}</>;
};
